var _g, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgressEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 124,
    viewBox: "0 0 136 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3334_75842)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.0273,
    y: 90.6929,
    width: 87.7823,
    height: 8.49506,
    fill: "#1B3554"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.7344,
    y: 18.4849,
    width: 87.7823,
    height: 55.9258,
    fill: "#E0E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7327 18.4849V103.436H10.5742V52.0663L24.7327 18.4849Z",
    fill: "#CFD4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.514 18.4849V102.728H125.965V52.0663L112.514 18.4849Z",
    fill: "#CFD4DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5742 51.7573H125.966V102.716C125.966 105.459 123.742 107.683 120.999 107.683H15.5411C12.798 107.683 10.5742 105.459 10.5742 102.716V51.7573Z",
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.70359,
    height: 21.1849,
    rx: 3.8518,
    transform: "matrix(-0.729257 -0.68424 -0.68424 0.729257 108.531 16.5278)",
    fill: "#F5A01D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.70359,
    height: 21.1849,
    rx: 3.85179,
    transform: "matrix(-0.999493 0.0318314 0.0318314 0.999493 72.1758 0)",
    fill: "#F5A01D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.70359,
    height: 21.1849,
    rx: 3.8518,
    transform: "matrix(-0.68424 0.729257 0.729257 0.68424 33.3633 9.38428)",
    fill: "#F5A01D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3334_75842",
    x: 0.000646591,
    y: 66.6662,
    width: 135.835,
    height: 56.5485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0133,
    result: "effect1_foregroundBlur_3334_75842"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressEmpty);
export default __webpack_public_path__ + "static/media/InProgressEmpty.9c60a791c6ed3694b7d2c4e000edcc19.svg";
export { ForwardRef as ReactComponent };